<template>
      <div class="card card-bike" v-if="bike">
         <router-link :to="`/bicicleta/${bike.slug}`">
            <el-image
               @click="fixRelativeBody()"
               style="width: 100%; height: 190px"
               class="mb-2"
               :src="getCover((!bike.coverPhoto ? null : bike.coverPhoto))"
               fit="cover"/>
         </router-link>
         <router-link :to="`/bicicleta/${bike.slug}`">
            <h2 class="h5 font-weight-bold text-center pl-4 pr-4 mt-1">{{ bike.name }}</h2>
         </router-link>
         <div :class="showFooter ? 'pb-3' : 'pb-4'" class="text-center pl-2 pr-2">
            <h6 class="text-center text-muted"> <i class="el-icon-location-outline mr-1"></i>
               <span v-if="bike.address.city">{{bike.address.neighborhood}} , {{bike.address.city}}, {{bike.address.state}}</span>
               <span v-if="!bike.address.city">{{bike.address.name}}</span>
            </h6>
            <div class="text-muted mb-3">
               <!-- Caso tenha por hora e por mês  -->
               <span>
                 {{renderValuesBike}}
               </span>
            </div>
            <!-- <el-rate
               class="mt-2 mb-2"
               v-model="bike.rateMetrics.averageRating"
               disabled
               show-score
               text-color="#ff9900"
               score-template="{value}">
            </el-rate>-->
            <el-button
               type="primary"
               @click="$router.push(`/bicicleta/${bike.slug}`)"
               class="font-strong w-75 pt-2 pb-2 pt-md-1 pb-md-1 pl-4 pr-4 d-block m-auto"
               >Ver bicicleta
            </el-button>
         </div>
         <div v-if="showFooter">
            <hr>
            <router-link :to="`/anunciante/${bike.user._id}`">
               <div class="text-center mb-1" style="display: flex; gap: 10px; justify-content: center;">
                  <el-image
                     @click="fixRelativeBody()"
                     style="width: 30px; height: 30px;"
                     class="mb-2 rounded"
                     :src="getCover(bike.user.avatar)"
                     fit="cover"/>
                  <span class="text-muted" style="margin-top: 3px;">Anfitrião: {{ bike.user.firstName }} {{ bike.user.lastName }}</span>
               </div>
            </router-link>
         </div>
      </div>
</template>

<script>
import BikeImg from '@/helpers/GetBikeCover'

export default {
   name: 'CardBike.vue',
   props: {
      bike: Object,
      loading: {
         type: Boolean,
         default: true,
      },
      showFooter: {
         type: Boolean,
         default: true
      }
   },
   methods: {
      getCover(uri) {
         if (uri) {
            return BikeImg.getCover(uri);
         }
      },

      fixRelativeBody() {
         let body = document.querySelector("body");
         body.style.overflow = 'visible';
      },
   },
   computed: {
      renderValuesBike() {
         const money = v => this.$options.filters.currency(v)
         const renderfromTo = (f, t) => `Valores: ${money(f)} até ${money(t)}`
         const renderSingle = (v, label) => `Valor: ${money(v)}${label}`

         const { timeValue, dailyValue, weekValue, monthValue } = this.bike

         // Tem por hora e por mês
         if (timeValue && monthValue) {
            return renderfromTo(timeValue, monthValue)
         }

         // Não tem por mês, mas tem por hora e por semana
         if (!monthValue && timeValue && weekValue) {
            return renderfromTo(timeValue, weekValue)
         }

         // Não tem por mês e nem por semana, mas tem por hora e por dia
         if (!monthValue && !weekValue && timeValue && dailyValue) {
            return renderfromTo(timeValue, dailyValue)
         }

         // Não tem por hora, mas tem por dia e por mês
         if (!timeValue && dailyValue && monthValue) {
            return renderfromTo(dailyValue, monthValue)
         }

         // Não tem por hora e nem por mês, mas tem por dia e por semana
         if (!timeValue && !monthValue && dailyValue && weekValue) {
            return renderfromTo(dailyValue, weekValue)
         }

         // Não tem por hora, nem por dia, mas ter por semana e por mês
         if (!timeValue && !dailyValue && weekValue && monthValue ) {
            return renderfromTo(weekValue, monthValue)
         }

         // Tem somente por hora
         if (!monthValue && !weekValue && !dailyValue && timeValue) {
            return renderSingle(timeValue, '/hora')
         }

         // Tem somente por dia
         if (!timeValue && !weekValue && !monthValue && dailyValue) {
            return renderSingle(dailyValue, '/dia')
         }

         // Tem somente por semana
         if (!timeValue && !dailyValue && !monthValue && weekValue) {
            return renderSingle(weekValue, '/semana')
         }

         // Tem somente por mês
         if (!timeValue && !dailyValue && !weekValue && monthValue) {
            return renderSingle(monthValue, '/mês')
         }

         return 'Sob-consulta'

      }
   }
}
</script>

<style scoped>

</style>
